module.exports = __webpack_public_path__ + "img/hnpn_.df01d168.png";